export default __webpack_public_path__ + "b207e5ffcf55b7b910a0e107a6ab1daa.png";